"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStaticToasts = exports.STATIC_TOAST_KEY = void 0;
var _react = require("react");
var _appconfig = require("../../selectors/appconfig");
var _Context = require("../Context");
var _useSessionPersistedIds = require("./useSessionPersistedIds");
var _Snack = require("./Snack");
var _sanitizer = require("../../utils/sanitizer");
const STATIC_TOAST_KEY = exports.STATIC_TOAST_KEY = 'hidden_toast_ids';
const clickStaticAction = action => {
  const uri = (0, _sanitizer.sanitizeHref)(action.uri);
  if (uri) {
    window.open(uri, (0, _Snack.selectLinkTarget)(action.newTab) ? '_blank' : '_self', 'noopener');
  }
};
const useStaticToasts = () => {
  const appconfig = (0, _Context.useSelector)(_appconfig.getAppconfig);
  const {
    addId: hideId,
    isSelected: isHidden
  } = (0, _useSessionPersistedIds.useLocalPersistedIds)(STATIC_TOAST_KEY);
  const visibleToasts = (0, _react.useMemo)(() => {
    var _appconfig$announceme;
    return (_appconfig$announceme = appconfig.announcements) === null || _appconfig$announceme === void 0 ? void 0 : _appconfig$announceme.filter(toast => !isHidden(toast.id));
  }, [appconfig.announcements, isHidden]);
  const isVisible = (0, _react.useCallback)(toast => visibleToasts.some(({
    id
  }) => id === toast.id), [visibleToasts]);
  const hideToast = (0, _react.useCallback)(toast => {
    if (isVisible(toast)) hideId(toast.id);
  }, [hideId, isVisible]);
  const clickToast = (0, _react.useCallback)((toast, action) => {
    if (isVisible(toast)) clickStaticAction(action);
  }, [isVisible]);
  return {
    toasts: visibleToasts,
    hideToast,
    clickToast
  };
};
exports.useStaticToasts = useStaticToasts;